import {Collapse} from "antd";
import React from "react";

const Section = ({
     children,
     title,
     defaultExpanded = true,
     titleComponent,
     noDataComponent,
 }: any) => {
    return (
        <Collapse className="chat-summary-collapse" defaultActiveKey={defaultExpanded ? ['1'] : []}>
            <Collapse.Panel header={title} key="1">
                {
                    children || noDataComponent || (
                        <p>Summary content goes here...</p>
                    )
                }
            </Collapse.Panel>
        </Collapse>
    )
}

export default Section;